<a (click)="startResendCode()">
  send another email.
  <icon *ngIf="reSendCodeProcessing" icon="refresh"
    class="-refresh -infinite-spin -sm151"></icon>
</a>